import React, { useState, useEffect } from 'react'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import {
  Button,
  ButtonToolbar,
  FlexboxGrid,
  Grid,
  Row,
  Col,
  Panel,
  Icon,
  Loader,
  Placeholder,
} from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import { withdrawSecureApproveSuccess } from '../../redux/actions/withdrawRequest'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function PaymentApproveRedirect() {
  const [response, setResponse] = useState()
  const referenceID = location.search.substring(13)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const { Paragraph } = Placeholder

  const _styles = {
    panel: {
      backgroundColor: '#34a888',
    },
    titleMesage: {
      color: '#ffffff',
    },
    content: {
      marginTop: 20,
    },
    icon: {
      paddingRight: 10,
    },
    footer: {
      marginTop: 15,
    },
    button: {
      width: 120,
      color: '#ffffff',
      backgroundColor: '#575757',
      fontWeight: 'bold',
      fontSize: '14 !important',
    },
  }

  useEffect(() => {
    // console.log('load ref ID => ', referenceID)
    handleGetResponse(referenceID)
  }, [])

  const handleGetResponse = async (referenceID) => {
    setIsLoading(true)
    startLoading()

    try {
      const res = await withdrawSecureApproveSuccess(referenceID)
      // console.log('res => ', res)
      setResponse(res)
    } catch (e) {
      console.log('error => ', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <Grid className="page-home">
        <TopLevelNav />
        <PageToolbar />
        <Row>
          <FlexboxGrid align="middle" className="banner">
            <FlexboxGrid.Item componentClass={Col} colspan={24} md={24}>
              <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Row>
      </Grid>
    )
  }

  if (!response || isLoading) {
    return (
      <Grid className="page-home">
        <TopLevelNav />
        <PageToolbar />
        <Row>
          <FlexboxGrid align="middle" className="banner">
            <FlexboxGrid.Item componentClass={Col} colspan={24} md={24}>
              <Panel bordered style={_styles.panel}>
                {/* <Loader
                  size="md"
                  backdrop
                  content={<b>กรุณารอสักครู่ ระบบกำลังทำรายการ...</b>}
                  center
                /> */}
                <OverlayLoader />
                <PanalLoadingTemplate />
              </Panel>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Row>
      </Grid>
    )
  }

  return (
    <>
      <Grid className="page-home">
        <TopLevelNav />
        <PageToolbar />
        <Row>
          <FlexboxGrid align="middle" className="banner">
            <FlexboxGrid.Item componentClass={Col} colspan={3} md={2}></FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} colspan={18} md={18}>
              <Panel bordered style={_styles.panel}>
                <h3 style={_styles.titleMesage}>message</h3>
                <h1>PAYMENT APPROVED</h1>
                <div style={_styles.content}>
                  <h3>
                    <Icon icon="check-square-o" size="3x" style={_styles.icon} />
                    {response.approvedMessage}
                  </h3>
                  <hr />
                  <h5>{response.description}</h5>
                </div>
                <div style={_styles.footer}>
                  <Button
                    size="sm"
                    appearance="default"
                    style={_styles.button}
                    onClick={() => {
                      sessionStorage.removeItem('projectId')
                      sessionStorage.removeItem('param')
                      window.location.href = '/'
                    }}
                  >
                    ตกลง
                  </Button>
                </div>
              </Panel>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} colspan={3} md={2}></FlexboxGrid.Item>
          </FlexboxGrid>
        </Row>
      </Grid>
    </>
  )
}
